export const checkPermission = (user: any, company: any, route?: string) => {
    let currentPath = route ? route : window.location.pathname;
    if (currentPath == '/login' || currentPath == '/') {
        return true;
    }
    if (currentPath.includes('details')) {
        currentPath = currentPath.replace(/\d+/g, 'id');
    }
    try {
        const currentModule = company.allModules.filter((module: any) => module.permissions.filter((permission: any) => permission.route == currentPath).length > 0);
        let res = false;
        if (currentModule.length > 0) {
            if (user.isOwner && company.assignedModules.filter((module: any) => module.id == currentModule[0].id).length > 0) {
                res = true;
            } else if (user.permissions.filter((permission: any) => permission.id == currentModule[0].id).length > 0) {
                const permission = user.permissions.filter((permission: any) => permission.id == currentModule[0].id)[0];
                console.log(permission);
                // Check if the company has this module assigned
                if (company.assignedModules.filter((module: any) => module.id == permission.id).length == 0) {
                    res = false;
                }
                if (permission.write && currentPath.includes('add')) {
                    res = true;
                } else if (permission.read && (currentPath.includes('details') || !currentPath.includes('add'))) {
                    res = true;
                }
                res = false;
            }
        }
        if (user.isOwner && company.assignedModules.filter((module: any) => module.name == 'ALL').length > 0) {
            res = true;
        }
        return res;
    } catch (e) {
        return false;
    }
    return false;
}


export const checkActionPermission = (user: any, company: any, action: string) => {
    try {
        let currentPath = window.location.pathname;
        if (currentPath == '/login' || currentPath == '/') {
            return true;
        }
        if (currentPath.includes('details')) {
            currentPath = currentPath.replace(/\d+/g, 'id');
        }
        const currentModule = company.allModules.filter((module: any) => module.permissions.filter((permission: any) => permission.route == currentPath).length > 0);
        if (currentModule.length > 0) {
            if (user.isOwner && company.assignedModules.filter((module: any) => module.id == currentModule[0].id).length > 0) {
                return true;
            } else if (user.permissions.filter((permission: any) => permission.id == currentModule[0].id).length > 0) {
                const permission = user.permissions.filter((permission: any) => permission.id == currentModule[0].id)[0];
                if (permission.write && action == 'add') {
                    return true;
                } else if (permission.update && action == 'update') {
                    return true;
                } else if (permission.delete && action == 'delete') {
                    return true;
                } else if (permission.download && action == 'download') {
                    return true;
                } else if (permission.read && action == 'read') {
                    return true;
                }
            }
        }
        if (user.isOwner && company.assignedModules.filter((module: any) => module.name == 'ALL').length > 0) {
            return true;
        }
    } catch (e) {
        console.log(e);
        return false;
    }
    return false;
}
